import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { WithdrawalMethod } from 'src/app/services/payment/methods/methods.models';
import { DetectDeviceService } from 'src/app/services/utils/detect-device.service';
import { LoaderService } from 'src/app/services/utils/loader/loader.service';

@Component({
  selector: 'app-withdrawal-method-sheet',
  templateUrl: './withdrawal-method-sheet.component.html',
  styleUrls: ['./withdrawal-method-sheet.component.scss']
})
export class WithdrawalMethodSheetComponent extends BasePageComponent {

  constructor(
    private loaderService: LoaderService,
    public detectDeviceService: DetectDeviceService

  ) { super() }

  @Input() paymentList: WithdrawalMethod[];
  @Input() selectedMethod: WithdrawalMethod;
  @Output() paymentMethod = new EventEmitter<WithdrawalMethod>();
  selectWithdrawalName = $localize`:@@withdrawal-select-method:select withdrawal method`



  ngOnInit(): void {
    this.isDesktop = this.detectDeviceService.isDesktop();
  }

  selectPayment(payment: WithdrawalMethod) {
    this.paymentMethod.next(payment);
  }
}
